import { Form } from 'factorial-form'

class ShiftBulkDeleteForm extends Form {
  constructor(values: object = {}) {
    super(values, {
      id: 'number',
      start_at: 'string',
      end_at: 'string',
      employee_id: 'number',
    })
  }
}

export default ShiftBulkDeleteForm
